module.exports = __webpack_public_path__ + "static/media/voltgroom-2.d7e35309.jpg";